import { GroupsRounded, HowToRegRounded } from '@mui/icons-material';
import { Avatar } from '@mui/material';

const GroupAvatar = ({ group, size, ...props }) => {
    const Icon = group.todo ? HowToRegRounded : GroupsRounded;
    return (
        <Avatar
            sx={{
                backgroundColor: theme => theme.palette.primaryContainer.main,
                ...(size === 'large'
                    ? {
                          height: 64,
                          width: 64,
                          fontSize: 42,
                      }
                    : {
                          height: 48,
                          width: 48,
                          fontSize: 32,
                      }),
            }}
            {...props}
        >
            <Icon
                color="primary"
                {...(size ? { fontSize: 'inherit' } : { fontSize: 'inherit' })}
            />
        </Avatar>
    );
};

export default GroupAvatar;
